import Vapor from 'laravel-vapor';
import { usePage } from '@inertiajs/vue3';
import { App } from '@app/shared/types/generated-v2';

type UploadedFile = {
  uuid: string;
  bucket: string;
  key: string;
  url: string;
  headers: string[];
  extension: string;
};

export function useUpload() {
  function upload(file: File, progress?: (progress: number) => void): Promise<UploadedFile> {
    return Vapor.store(file, {
      visibility: 'public-read',
      progress,
      headers: {
        [App.Infrastructure.Headers.Header.X_EMBEDDED_TOKEN]:  'EFT.' + usePage().props.rpak,
      },
    });
  }

  return { upload };
}
